export default "__VITE_ASSET__BinnY44t__"